export const loginInputText = {
    "pt-br":{
        "1":"Seu CPF",
        "2":"Digite seu e-mail para confirmação de conta:",
        "3":"Digite o código de verificação",
        "4":"Digite a senha",
    },
    "en":{
        "1":"Your CPF",
        "2":"Enter your account confirmation email:",
        "3":"Enter the verification code",
        "4":"Enter the password",
    }
}

export const loginButtonText = {
    "pt-br":{
        "1":"Buscar",
        "2":"Enviar código",
        "3":"Verificar",
        "4":"Entrar",
    },
    "en":{
        "1":"Search",
        "2":"Send Verification code",
        "3":"Verify",
        "4":"Submit",
    }
}

export const loginLinkText = {
    "pt-br": "Logar como account",
    "en": "Log in as account"
}

export const adminLoginTitleText = {
    "pt-br": {
        "email": "E-mail",
        "password": "Senha"
    },
    "en": {
        "email": "E-mail",
        "password": "Password"
    }
}

export const adminLoginInputText = {
    "pt-br": {
        "email": "Digite o e-mail",
        "password": "Digite a senha"
    },
    "en": {
        "email": "Enter your e-mail",
        "password": "Enter your password"
    }
}

export const adminLoginButtonText = {
    "pt-br": "Entrar",
    "en": "Submit"
}

export const adminLoginLinkText = {
    "pt-br": "Logar como beneficiário",
    "en": "Log in as beneficiary"
}

export const menuLink = {
    "pt-br": {
        "contestacoes": "Contestações",
        "meus_atendimentos": "Meus Atendimentos",
        "perfil": "Perfil",
        "sair": "Sair"
    },
    "en": {
        "contestacoes": "Contestations",
        "meus_atendimentos": "My medical appointments",
        "perfil": "Profile",
        "sair": "Logout"
    }
}

export const listContestationsTitle = {
    "pt-br": "Lista de contestações",
    "en": "Contestations list"
}

export const listContestationsInput = {
    "pt-br": "Buscar por nome ou status",
    "en": "Search by name or status"
}

export const listContestationsButton = {
    "pt-br": "Buscar",
    "en": "Search"
}

export const listContestationsTableHeader = {
    "pt-br": {								
        "empresa": "Empresa",	
        "nome": "Nome",	
        "solicitacao": "Solicitação",	
        "tipo_do_atendimento": "Tipo do atendimento",	
        "descricao_do_atendimento": "Descrição do atendimento",	
        "alterado_por": "Alterado por",	
        "status": "Status",	
        "criado_em": "Criado em",	
        "acoes": "Ações",
    },
    "en": {								
        "empresa": "Company",
        "nome": "Name",
        "solicitacao": "Request",
        "tipo_do_atendimento": "Service type",
        "descricao_do_atendimento": "Description of service",
        "alterado_por": "Changed by",
        "status": "State",
        "criado_em": "Created on",
        "acoes": "Actions",
    }
}

export const listContestationsPagesButton = {
    "pt-br": {
        "voltar": "Voltar",
        "avancar": "Avançar"
    },
    "en": {
        "voltar": "Previous",
        "avancar": "Next"
    }
}

export const listContestationsModalTitle = {
    "pt-br": "Cancelar contestação",
    "en": "Cancel Contestation"
}

export const listContestationsModalInputTitle = {
    "pt-br": "Motivo do cancelamento",
    "en": "Reason for cancellation"
}

export const listContestationsModalInput = {
    "pt-br": "Digite o motivo do cancelamento",
    "en": "Enter reason for cancellationn"
}

export const listContestationsModalButton = {
    "pt-br": {
        "avancar": "Concluir",
        "voltar": "Voltar"
    },
    "en": {
        "avancar": "Save",
        "voltar": "Back"
    }
}

export const formContestationTitle = {
    "pt-br": "Detalhes da contestação",
    "en": "Contestation details"
}

export const formContestationLGPDText = {
    "pt-br": "Em observância à Lei nº. 13.709/18 – Lei Geral de Proteção de Dados Pessoais e demais normativas aplicáveis sobre proteção de Dados Pessoais, manifesto-me de forma informada, livre, expressa e consciente, no sentido de autorizar a corretora Sciath a realizar a análise necessária junto a operadora de saúde para esclarecer a contestação que estou encaminhando sobre a utilização do plano de saúde acima",
    "en": "In compliance with Law no. 13.709/18 - General Law for the Protection of Personal Data and other applicable regulations on the protection of Personal Data, I express myself in an informed, free, express and conscious way, in order to authorize the Sciath brokerage to carry out the necessary analysis with the health to clarify the dispute that I am submitting about the use of the health plan above"
}

export const formButton = {
    "pt-br": {
        "avancar": "Salvar",
        "voltar": "Voltar"
    },
    "en": {
        "avancar": "Save",
        "voltar": "Back"
    }
}

export const formContestationInputTile = {
    "pt-br": {								
        "codigo_identificacao": "Código de identificação",	
        "nome": "Nome",	
        "email": "E-mail",	
        "codigo_procedimento": "Código Procedimento",	
        "numero_conta": "Número da Conta",	
        "descricao_servico": "Descrição Serviço",	
        "status": "Status",	
        "descricao": "Descrição",	
        "prestador": "Prestador",
        "cpf_titular": "CPF Titular",
        "celular": "Celular",
        "rede_cred_reembolso": "Rede Credenciada/Reembolso",
        "data_atendimento": "Data do Atendimento",
        "Tipo_atendimento": "Tipo do Atendimento",
    },
    "en": {			
        "codigo_identificacao": "Identification code",
        "nome": "Name",
        "email": "E-mail",
        "codigo_procedimento": "Procedure Code",
        "numero_conta": "Account Number",
        "descricao_servico": "Service description",
        "status": "Status",
        "descricao": "Description",
        "prestador": "Provider",
        "cpf_titular": "CPF Holder",
        "celular": "Mobile",
        "rede_cred_reembolso": "Network provider/Refund",
        "data_atendimento": "Date of Service",
        "Tipo_atendimento": "Service Type",				
    }
}

export const formContestationDropdown1 = {
    "pt-br": {
        "nao_iniciado": "Não iniciado",
        "em_andamento": "Em andamento",
        "concluido": "Concluido"
    },
    "en": {
        "nao_iniciado": "Not started",
        "em_andamento": "In progress",
        "concluido": "Completed"
    }
}

export const formContestationDropdown2 = {
    "pt-br": {
        "aceito": "Aceito",
        "nao_aceito": "Não aceito"
    },
    "en": {
        "aceito": "Accepted",
        "nao_aceito": "Not accepted"
    }
}

export const profileTitle = {
    "pt-br": "Dados de cadastro",
    "en": "Registration data"
}

export const profileModalTitle = {
    "pt-br": "Alterar senha",
    "en": "Change password"
}

export const profileModalInputTitle = {
    "pt-br": {								
        "senha": "Senha",	
        "confirme_senha": "Confirme Senha"
    },
    "en": {		
        "senha": "Password",	
        "confirme_senha": "Confirm password"		
    }
}

export const profileInputTitle = {
    "pt-br": {								
        "nome": "Nome",	
        "cpf": "CPF",	
        "email": "E-mail",	
        "empresa": "Empresa",	
        "cpf_titular": "CPF Titular",	
        "celular": "Celular",	
    },
    "en": {		
        "nome": "Name",	
        "cpf": "CPF",	
        "email": "E-mail",	
        "empresa": "Company",	
        "cpf_titular": "CPF Holder",	
        "celular": "Mobile",				
    }
}

export const profileLink = {
    "pt-br": "Alterar Senha",
    "en": "Change Password"
}